<script>
  import { RedIntegerFormat } from "three";

  import Game from "./Game.svelte";
  import Home from "./Home.svelte";
  import Scan from "./Scan.svelte";

  const state = {
    screen: "home",
    imageId: null,
  };

  const startScan = () => {
    state.screen = "scan";
  };

  const loadImage = (index) => {
    // this is dirty...
    state.screen = "game";
    let strId;
    switch (index) {
      case 1:
        strId = "01";
        break;
      case 2:
        strId = "02";
        break;
      case 3:
        strId = "03";
        break;
      case 4:
        strId = "04";
        break;
      case 5:
        strId = "05";
        break;
      case 6:
        strId = "06";
        break;
      case 7:
        strId = "07";
        break;
      case 8:
        strId = "08";
        break;
      case 9:
        strId = "09";
        break;
      case 10:
        strId = "10";
        break;
      case "1":
        strId = "01";
        break;
      case "2":
        strId = "02";
        break;
      case "3":
        strId = "03";
        break;
      case "4":
        strId = "04";
        break;
      case "5":
        strId = "05";
        break;
      case "6":
        strId = "06";
        break;
      case "7":
        strId = "07";
        break;
      case "8":
        strId = "08";
        break;
      case "9":
        strId = "09";
        break;
      case "10":
        strId = "10";
        break;
    }
    // console.log("load imag", strId);
    state.imageId = strId;
  };
</script>

<main class="overflow-hidden">
  {#if state.screen == "home"}
    <Home {startScan} {loadImage} />
  {/if}

  {#if state.screen == "game"}
    <Game {startScan} imageId={state.imageId} />
  {/if}

  {#if state.screen == "scan"}
    <Scan {loadImage} />
  {/if}
</main>

<style>
</style>
